import styled from 'styled-components';

export const Container = styled.label`
  color: #6c757d;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
`;
